/*
 * @Author: qin 15936669602@163.com
 * @Date: 2024-01-15 18:04:18
 * @LastEditors: qin 15936669602@163.com
 * @LastEditTime: 2025-07-14 21:46:31
 * @FilePath: /360-house-viewing-main/src/assets/js/const.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { baseURL } from "../../utils/config";
// const prefix_url = "http://img.zhi119.com";
const prefix_url = baseURL;

export { prefix_url };
